export enum EReduxAsyncState {
  idle = 'IDLE',
  inProgress = 'IN_PROGRESS',
  success = 'SUCCESS',
  failed = 'FAILED',
}
